var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":_vm.ExportPDF}},'v-btn',attrs,false),on),[_c('v-img',{attrs:{"lazy-src":"/assets/images/pdf.png","max-height":"32","max-width":"32","src":"/assets/images/pdf.png"}})],1)]}}])},[_c('span',[_vm._v("PDF Olarak Kaydet")])])}
var staticRenderFns = []

export { render, staticRenderFns }